import React, { useState, useEffect, useRef } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi';
import LinhaDoTempo from '../../../../components/LinhaDoTempo/index';
import ContentLoader from 'react-content-loader';
import ReactToPrint from 'react-to-print';
import { meses } from '../../../../util/Utilitarios';
import { Imprimir, MinimizarDados } from '../../../../components/Acoes';
import Interweave from 'interweave';
import moment from 'moment';
import { getUsuario } from '../../../../util/Configuracoes';

const TITULO_ENUM = {
    38: 'Agenda Reserva',
    76: 'Guia Convênio',
    107: 'Guia Particular',
    171: 'Consulta pré-Anestésica',
    177: 'Indicadores Assistenciais'
}

const ICONE_ENUM = {
    38: 'icon-Calendar-3',
    76: 'icon-File-TextImage',
    107: 'icon-File-TextImage',
    171: 'icon-Tablet',
    177: 'icon-Tablet'
}

const VISUALIZACAO_ENUM = {
    38: '/administracao/agendareserva/visualizacao',
    76: '/faturamento/guia/visualizacao',
    107: '/faturamento/guia-particular/visualizacao',
    171: '/preanestesico/consultapreanestesico/visualizacao',
    177: '/posanestesico/consultaposanestesico/visualizacao'
}

export default function Timeline(props) {
    let { id } = useParams();
    const user = getUsuario();
    const [dados, setDados] = useState();
    const [dadosLinhaDoTempo, setDadosLinhaDoTempo] = useState();
    const [nomePaciente, setNomePaciente] = useState('');
    const [carregando, setCarregando] = useState(true);
    const actualDate = new Date();
    const btnPrint = useRef();
    const reference = useRef();
    const [minimizar, setMinimizar] = useState([])

    useEffect(() => {
        visualizar('/faturamento/beneficiarioTimeline', id,
            obj => {
                if (obj) {
                    setNomePaciente(obj?.paciente?.nome);
                    setDados(obj?.paciente?.id ? {
                        id,
                        modulo: props.modulo,
                        titulo: 'Dados do Beneficiário',
                        grupos: [
                            {
                                titulo: 'Dados Beneficiário',
                                colunas: [
                                    { titulo: 'Código', descricao: obj?.paciente?.id, tamanho: 'col-lg-4' },
                                    { titulo: 'Nome', descricao: obj?.paciente?.nome, tamanho: 'col-lg-4' },
                                    { titulo: 'Nome Social', descricao: obj?.paciente?.nome_social, tamanho: 'col-lg-4' },
                                    { titulo: 'Data de Nascimento', descricao: obj?.paciente?.data_nascimento, tamanho: 'col-lg-4' },
                                    { titulo: 'CPF', descricao: obj?.paciente?.cpf, tamanho: 'col-lg-4' },
                                    { titulo: 'RG', descricao: obj?.paciente?.rg, tamanho: 'col-lg-4' },
                                    { titulo: 'CNS', descricao: obj?.paciente?.cns, tamanho: 'col-lg-4' },
                                    { titulo: 'Plano', descricao: obj?.paciente?.plano, tamanho: 'col-lg-4' },
                                    { titulo: 'N° Carteira', descricao: obj?.paciente?.numero_carteira, tamanho: 'col-lg-4' },
                                    { titulo: 'Validade Carteira', descricao: obj?.paciente?.validade_carteira, tamanho: 'col-lg-4' },
                                    { titulo: 'Operadora Saúde', descricao: obj?.paciente?.operadora_saude && obj?.paciente?.operadora_saude[0].label || "", tamanho: 'col-lg-4' },
                                    { titulo: 'Email', descricao: obj?.paciente?.email, tamanho: 'col-lg-4' },
                                    { titulo: 'Data de Registro', descricao: obj?.paciente?.data_registro, tamanho: 'col-lg-4' },
                                ]
                            }
                        ]
                    } : { titulo: 'Dados do Beneficiário' })

                    let dadosFormatados = obj?.timeline?.map(x => ({
                        data: x.data_formatada,
                        evento: TITULO_ENUM[x.modulo],
                        conteudo:
                            (
                                <>
                                    <p><b>Procedimento(s): </b></p>
                                    {x.procedimentos ? <>
                                        <ul>
                                            {x.procedimentos.map(x => <li>{x}</li>)}
                                        </ul>
                                    </> : <span>Nenhum procedimento executado.</span>}

                                </>
                            ),
                        icone: ICONE_ENUM[x.modulo],
                        siglas: x.socios || [],
                        url_visualizar: `${VISUALIZACAO_ENUM[x.modulo]}/${x.id}`
                    }))

                    setDadosLinhaDoTempo(dadosFormatados);

                }
                setCarregando(false);
            })
    }, [id])

    return (carregando ? <div className="card">
        <div className="card-body">
            <div className={'d-none-print colored'}>
                <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0'}>
                    <ContentLoader
                        speed={2}
                        width={800}
                        height={400}
                        viewBox="0 0 800 400"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                    >
                        <rect x="30" y="20" rx="5" ry="5" width="50" height="20" />

                        <rect x="50" y="50" rx="3" ry="3" width="4" height="300" />

                        <circle cx="50" cy="80" r="10" />
                        <circle cx="50" cy="160" r="10" />
                        <circle cx="50" cy="240" r="10" />

                        <rect x="80" y="65" rx="5" ry="5" width="600" height="40" />
                        <rect x="80" y="145" rx="5" ry="5" width="600" height="40" />
                        <rect x="80" y="225" rx="5" ry="5" width="600" height="40" />

                        <rect x="100" y="110" rx="5" ry="5" width="560" height="20" />
                        <rect x="100" y="190" rx="5" ry="5" width="560" height="20" />
                        <rect x="100" y="270" rx="5" ry="5" width="560" height="20" />
                    </ContentLoader>
                </div>
            </div>
        </div>
    </div > : <React.Fragment>
        <div className="card" ref={reference}>
            <ReactToPrint
                trigger={() => <button className={"hidden d-none"} ref={btnPrint} />}
                content={() => reference.current} pageStyle={`@page { size: ${props.orientacao || 'a4 auto'} }`} />
            <div className="card-body">
                <div className={'d-block-print'}>
                    <div className={'col-12 row mt-3'}>
                        <div className="col-8">
                            <h5>{'Linha do Tempo'}</h5>
                            <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                        </div>
                        <div className="col-4 text-right">
                            <img alt='logo' className="logo-menu" src={require('../../../../assets/img/logo-menu.png')}></img>
                        </div>
                    </div>
                </div>
                <div className={'d-none-print colored'}>
                    <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0'}>
                        <div className="col-12 row-space-between pr-0 pl-0">
                            <div>
                                {/* <BtnAcao icone="icon-Arrow-Left" texto="Voltar" action={() => props.history.goBack()} /> */}
                            </div>
                            <div className="text-right">
                                <Imprimir action={() => btnPrint.current.click()} />
                            </div>
                        </div>
                        <div className="col-12 titulo-visualizacao">
                            <h5>{'Linha do Tempo'}</h5>
                            <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                        </div>
                    </div>
                </div>
                {dados ?
                    <React.Fragment>
                        {dados.grupos ? dados.grupos.filter(x => x.visivel !== false).map((grupo, index, arrayAtual) => grupo &&
                            <div className={"dados-visualizacao mb-20 " + (minimizar[index] === false ? "d-none-print" : "")} key={index}>

                                <div className="group-title row-space-between ">
                                    <h5> {grupo.titulo} </h5>
                                    {grupo.minimizar ? <div className='d-none-print'> <MinimizarDados className={"visualizacao " + (minimizar[index] === false ? "strikediag" : "")}
                                        texto={minimizar[index] === true || minimizar[index] === undefined ? "Esconder na Impressão " : "Mostrar na Impressão"} action={() => {
                                            if (minimizar.length > 0) {
                                                let cloneArray = [...minimizar]
                                                cloneArray[index] = !cloneArray[index]
                                                setMinimizar(cloneArray)
                                            } else {
                                                let cloneArray = Array(arrayAtual.length).fill(true)
                                                cloneArray[index] = false
                                                setMinimizar(cloneArray)
                                            }

                                        }

                                        } /> </div> : <></>}

                                </div>
                                <div className="row">
                                    {grupo.colunas && grupo.colunas.map((coluna, index) => coluna &&
                                        <div key={index} className={coluna.tamanho + ' col-sm-12 mb-20'}>
                                            <span className="data-title">{coluna.titulo}</span>
                                            {coluna.htmlDireto ? coluna.htmlDireto :
                                                (coluna.html ? <Interweave content={coluna.descricao.toString()} /> : <span >{coluna.descricao}</span>)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : <div className="dados-visualizacao">
                            <div className="group-title">
                                <h5>Não há Dados!</h5>
                            </div>
                        </div>}
                    </React.Fragment>
                    : null}

                <div className={'colored'}>
                    <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0 mt-40'}>
                        <div className="col-12 titulo-visualizacao">
                            <h5>{nomePaciente}</h5>
                            <h6>{'Linha do tempo'}</h6>
                        </div>
                    </div>
                </div>
                <LinhaDoTempo dados={dadosLinhaDoTempo} />
                <div className="footer-only-print-visualizacao">
                    <div className="col-md-12">
                        <span><i>Visualização Emitida <b>{user.nome}</b> no dia {moment().format('DD/MM/YYYY')} às {moment().format('HH:mm:ss')}</i></span>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
    );
}